import { useEffect, useRef } from "react";

const useClickOutside = (handler) => {
    const domNode = useRef();

    useEffect(() => {
        const maybeHandler = (event) => {
            if (domNode.current && !domNode.current.contains(event.target)) {
                handler(); 
            }
        };

        document.addEventListener("mousedown", maybeHandler);
        document.addEventListener("touchstart", maybeHandler);

        return () => {
            document.removeEventListener("mousedown", maybeHandler);
            document.removeEventListener("touchstart", maybeHandler);
        };
    }, [handler]);

    return domNode;
};

export default useClickOutside;